import { jsPDF } from 'jspdf';

export interface DeliveryOrderPdfData {
  orderNo: string;
  date: string;
  yardName: string;
  yardAddress: string;
  material: string;
  quantity: number;
  unit: string;
  deliveredPerUnit: number;
  deliveredTotal: number;
  siteName?: string;
  siteAddress: string;
}

export function buildDeliveryOrderPdf(o: DeliveryOrderPdfData) {
  const doc = new jsPDF({ unit: 'pt', format: 'letter' });
  doc.setFontSize(20);
  doc.text('Cornerstone Bulk Materials', 40, 50);
  doc.setFontSize(13);
  doc.text('DELIVERY ORDER', 40, 72);
  doc.setFontSize(10);
  doc.text(`Order #: ${o.orderNo}`, 400, 50);
  doc.text(`Date: ${o.date}`, 400, 66);

  // From (yard)
  doc.text('From Yard:', 40, 110);
  doc.text(`${o.yardName}\n${o.yardAddress}`, 120, 110);

  // Deliver to (site)
  doc.text('Deliver To:', 40, 150);
  doc.text(`${o.siteName ?? ''}\n${o.siteAddress}`, 120, 150);

  // Line item table
  doc.line(40, 200, 560, 200);
  doc.text('Material', 40, 218);
  doc.text('Qty', 300, 218);
  doc.text('$/Unit', 380, 218);
  doc.text('Total', 480, 218);
  doc.line(40, 226, 560, 226);
  doc.text(o.material, 40, 244);
  doc.text(`${o.quantity} ${o.unit}`, 300, 244);
  doc.text(`$${o.deliveredPerUnit.toFixed(2)}`, 380, 244);
  doc.text(`$${o.deliveredTotal.toFixed(2)}`, 480, 244);

  doc.setFontSize(12);
  doc.text(`Delivered Total: $${o.deliveredTotal.toFixed(2)}`, 380, 290);
  doc.setFontSize(9);
  doc.text(
    'Driver signature: ______________________     Received: ______________________',
    40,
    360
  );
  doc.save(`delivery-order-${o.orderNo}.pdf`);
}
